// extracted by mini-css-extract-plugin
export var label = "_4z-1";
export var reminder = "_4z-0";